import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from '@/utils/index'
import { getToken } from '@/utils/auth'
import store from '../store'
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    name: 'home',
    component: _import('home/index')
  }, {
    path: '/menu/:id',
    name: 'menu',
    component: _import('home/common/menu'),
    meta: {
      title: '栏目',
      breadcrumb: [{
        title: '栏目'
      }]
    }
  }, {
    path: '/article/:id',
    name: 'article',
    component: _import('home/common/article'),
    meta: {
      title: '文章',
      breadcrumb: [{
        title: '文章'
      }]
    }
  }, {
    path: '/search',
    name: 'search',
    component: _import('home/search'),
    meta: {
      title: '检索结果',
      breadcrumb: [{
        title: '检索结果'
      }]
    }
  }, {
    path: '/questionnaire',
    name: 'questionnaire',
    component: _import('home/questionnaire/index'),
    meta: {
      title: '问卷调查',
      breadcrumb: [{
        title: '问卷调查'
      }]
    }
  }, {
    path: '/questionnaire/view/:id',
    name: 'questionnaireDetail',
    component: _import('home/questionnaire/view'),
    meta: {
      title: '详细问卷',
      breadcrumb: [{
        title: '问卷调查',
        path: '/questionnaire'
      }, {
        title: '详细问卷'
      }]
    }
  }, {
    path: '/questionnaire/summary/:id',
    name: 'questionnaireSummary',
    component: _import('home/questionnaire/summary'),
    meta: {
      title: '问卷统计结果',
      breadcrumb: [{
        title: '问卷调查',
        path: '/questionnaire'
      }, {
        title: '问卷统计结果'
      }]
    }
  }, {
    path: '/public',
    name: 'public',
    component: _import('home/public/index'),
    meta: {
      title: '公共服务',
      breadcrumb: [{
        title: '公共服务'
      }]
    }
  }, {
    path: '/record',
    name: 'record',
    component: _import('home/public/record'),
    meta: {
      title: '备案情况&年报情况',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '备案情况&年报情况'
      }]
    }
  }, {
    path: '/record_check',
    name: 'recordCheck',
    component: _import('home/public/recordCheck'),
    meta: {
      title: '机构备案进度查询',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '机构备案进度查询'
      }]
    }
  }, {
    path: '/report',
    name: 'report',
    component: _import('home/public/report'),
    meta: {
      title: '举报未备案机构',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '举报未备案机构'
      }]
    }
  }, {
    path: '/report_check',
    name: 'reportCheck',
    component: _import('home/public/reportCheck'),
    meta: {
      title: '未备案机构举报进度查询',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '未备案机构举报进度查询'
      }]
    }
  }, {
    path: '/report_check/detail/:id',
    name: 'reportCheckDetail',
    component: _import('home/public/reportCheckDetail'),
    meta: {
      title: '未备案机构举报进度查询',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '未备案机构举报进度查询'
      }]
    }
  }, {
    path: '/complaint/add',
    name: 'complaint',
    component: _import('home/public/complaint'),
    meta: {
      title: '投诉举报',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '投诉举报'
      }]
    }
  }, {
    path: '/complaint/edit/:id',
    name: 'editComplaint',
    component: _import('home/public/complaint'),
    meta: {
      title: '编辑投诉举报',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '编辑投诉举报'
      }]
    }
  }, {
    path: '/complaint/readme',
    name: 'complaintReadme',
    component: _import('home/public/complaintReadme'),
    meta: {
      title: '投诉受理须知',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '投诉受理须知'
      }]
    }
  }, {
    path: '/complaint_check',
    name: 'complaintCheck',
    component: _import('home/public/complaintCheck'),
    meta: {
      title: '投诉进度查询',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '投诉进度查询'
      }]
    }
  }, {
    path: '/complaint_check/detail/:id',
    name: 'complaintCheckDetail',
    component: _import('home/public/complaintCheckDetail'),
    meta: {
      title: '投诉进度详情',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '投诉进度详情'
      }]
    }
  }, {
    path: '/complaint_check/add/:id',
    name: 'complaintCheckAdd',
    component: _import('home/public/complaintCheckAdd'),
    meta: {
      title: '补充书证',
      breadcrumb: [{
        title: '公共服务',
        path: '/public'
      }, {
        title: '补充书证'
      }]
    }
  }, {
    path: '/remember/president',
    name: 'rememberPresident',
    component: _import(`home/public/rememberPresident${isMobile() ? 'Mobile' : ''}`),
    meta: {
      title: '缅怀会长',
      breadcrumb: [{
        title: '缅怀会长'
      }]
    }
  }, {
    path: '/poster',
    name: 'poster',
    component: _import(`home/public/poster`),
    meta: {
      title: '海报',
      breadcrumb: [{
        title: '海报'
      }]
    }
  }, {
    path: '*',
    redirect: '/',
    hidden: true
  }]
})

router.beforeEach(async (to, from, next) => {
  if (getToken() && !store.getters.dictdata) await store.dispatch('GetUserInfo')
  if (!store.getters.homeColumns) await store.dispatch('getHomeColumns')
  if (!store.getters.webInfo) await store.dispatch('getWebInfo')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/home.js